import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { GoogleOAuthProvider } from '@react-oauth/google';

import configureStore, { history } from './store';

import AppRouter from './Routes';
import { authConfig } from './configs';

import 'normalize.css';
import 'antd/dist/antd.css';
import './App.scss';
import './components/common/common.scss';

const store = configureStore();

const App = () => {
  return (
    <Provider store={store}>
      <GoogleOAuthProvider clientId={authConfig.clientId}>
        <ConnectedRouter history={history}>
          <AppRouter />
        </ConnectedRouter>
      </GoogleOAuthProvider>
    </Provider>
  );
};

export default App;
